
import { useToast } from '@/hooks/use-toast';
import { FastingProtocol } from '@/types/fasting';

export const useMilestoneChecker = (selectedProtocol: FastingProtocol) => {
  const { toast } = useToast();

  const checkMilestones = (previousElapsed: number, currentElapsed: number) => {
    selectedProtocol.milestones.forEach(milestone => {
      const milestoneTime = milestone.hour * 60 * 60;
      if (previousElapsed < milestoneTime && currentElapsed >= milestoneTime) {
        toast({
          title: milestone.title,
          description: milestone.description,
        });
      }
    });
  };

  return { checkMilestones };
};
